import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRemovals } from '../../actions/removals';
import SearchableList from '../partials/SearchableList';
import SelectableListItem from '../partials/SelectableListItem';
import InspectionStartModal from './InspectionStartModal';
import { startInspection} from '../../actions/inspections';
import { resetInspectionState } from '../../actions/start-inspection';
//import Modal from '../modal';
import { destructServerErrors, allErrors } from '../../helpers/error';
import __ from '../../helpers/translation';
import localforage from "localforage";

const propTypes = {
  onSelected: PropTypes.func.isRequired,
  getRemovals: PropTypes.func.isRequired,
  startInspection: PropTypes.func.isRequired,
  resetInspectionState: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  currentItem: PropTypes.object,
  onRef: PropTypes.func.isRequired
};

class RemovalSelect extends Component {

    constructor (props) {
      super(props);
      this.searchList = React.createRef();
      this.removals = [];
      this.currentItem = props.currentItem ? props.currentItem : null;
      this.onSelected = props.onSelected;
      this.template = this.template.bind(this);

      this.state = {
        modal: {
          'loading': false,
          'show': false
        },
      }

      this.props.onRef(this);
    }

    template(item){
      return <SelectableListItem 
        key={item.id.toString()}
        id={item.id.toString()}
        name={'removals'}
        title={item.name}
        selected={this.currentItem && this.currentItem.id == item.id}
        onSelect={(e) => this.onSelected(item)}
        image={window.App.baseUrl + 'assets/app/img/icon_pakkingen.png'}
      />;
    }

    handleModal(e){
      e.preventDefault();

      this.setState({
        'modal': {
          'loading': true
        }
      });

      this.props.startInspection({ 
        'company_id': this.props.data.selectedCompany.id,
        'location_id': this.props.data.selectedLocation.id,
        'sublocation_id': this.props.data.selectedSublocation.id,
        'removal_id': this.props.data.selectedRemoval.id
      })
        .then(data => {
          this.props.resetInspectionState();
        })
        .catch(error => {
          let errors = typeof error === 'string' ?
            error :
            allErrors(destructServerErrors(error));
          this.setState({
            'modal': {
              'loading': false,
              'errors': errors
            }
          });
        });

    }

    componentDidMount () {
        if (window.navigator.onLine) {
            this.props.getRemovals()
                .then(data => {
                    this.removals = data.removals;
                    this.searchList.current.setState({
                        items: data.removals,
                        loading: false
                    })
                })
                .catch(error => {
                    return Promise.reject(error)
                })
        } else {
            try {
                localforage.getItem('bs_removals')
                    .then(removals => {
                        if (removals) {
                            this.removals = removals;
                            this.searchList.current.setState({
                                items: removals,
                                loading: false
                            })
                        }
                    });

                return Promise.resolve({ ...this.removals });

            } catch (e) {
                return Promise.reject(e);
            }
        }
    }

    componentWillUnmount() {
      this.props.onRef(undefined);
      window.$('.modal-backdrop').remove();
    }

    showModal(){
      window.$('#modalInspectionStart').modal('show');
    }

    render () {
        return (

            <Fragment>
                <h1 className="fw-600 d-inline-block">{ __('app.inspections.title_removal') }</h1>
                <SearchableList
                  ref={this.searchList}
                  template={this.template}
                  items={this.removals}
                  searchField={'name'}
                  loading={true}
                />
                <InspectionStartModal 
                  modal={this.state.modal} 
                  data={this.props.data} 
                  callback={(e) => this.handleModal(e)} 
                />
            </Fragment>

        )
    }
}

RemovalSelect.propTypes = propTypes;

const mapDispatchToProps = {
  getRemovals,
  startInspection,
  resetInspectionState,
};

export default connect(null, mapDispatchToProps)(RemovalSelect);